
export class RunContext {
    cancelled: boolean = false

    cancel() {
        this.cancelled = true;
    }
}